/*! @azure/msal-common v15.2.1 2025-03-11 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const CcsCredentialType = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN",
};

export { CcsCredentialType };
//# sourceMappingURL=CcsCredential.mjs.map
